import * as React from "react";
import { useState, useEffect } from "react";
import { Card, Typography } from "@mui/material";
import { ChromePicker } from "react-color";

export default function ColorSelector({ theme, updateTheme, dropDownId }) {
  let initialVal;
  if (dropDownId === "headerColor") {
    initialVal = theme?.headerColor;
  } else if (dropDownId === "primaryButtonColor") {
    initialVal = theme?.primaryButtonColor;
  } else if (dropDownId === "headerTextColor") {
    initialVal = theme?.headerTextColor;
  } else {
    initialVal = theme?.buttonTextColor;
  }
  const [color, setColor] = useState(initialVal);
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const [debouncedApiCall, setDebouncedApiCall] = useState(null);

  useEffect(() => {
    setColor(initialVal?.toUpperCase());
  }, [initialVal]);

  const handleClose = () => {
    setDisplayColorPicker(false);
  };
  const handleClick = () => {
    setDisplayColorPicker((prev) => !prev);
  };

  const popover = {
    position: "absolute",
    zIndex: "2",
  };
  const cover = {
    position: "fixed",
    top: "0px",
    right: "0px",
    bottom: "0px",
    left: "0px",
  };

  const handleColorSelector = (color) => {
    setColor(color.hex);
    if (debouncedApiCall) {
      clearTimeout(debouncedApiCall);
    }

    const newDebouncedApiCall = setTimeout(() => {
      updateTheme(dropDownId, color.hex);
    }, 300);

    setDebouncedApiCall(newDebouncedApiCall);
  };

  return (
    <div>
      <Card
        variant="outlined"
        sx={{
          width: "118px",
          display: "flex",
          height: "36px",
        }}
      >
        <div
          onClick={handleClick}
          style={{
            width: "30px",
            height: "36px",
            border: "none",
            borderRight: "1px solid #E0E0E0",
            cursor: "pointer",
            background: color,
          }}
        />

        <div
          style={{
            height: "36px",
            display: "flex",
            width: "88px",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={handleClick}
        >
          <Typography
            sx={{
              color: "rgba(1, 1, 2, 0.65) !important",
              fontSize: "14px !important",
              fontStyle: "normal !important",
              fontWeight: "400 !important",
              lineHeight: "18px !important",
              letterSpacing: "0.28px !important",
              marginLeft: "6px",
            }}
          >
            {color?.toUpperCase()}
          </Typography>
        </div>
      </Card>
      {displayColorPicker ? (
        <div style={popover}>
          <div style={cover} onClick={handleClose} />
          <ChromePicker color={color} onChange={handleColorSelector} />
        </div>
      ) : null}
    </div>
  );
}
